import Eyebrow from '@/components/Eyebrow/Eyebrow';
import useGlobalStyles, { ResponsiveTypeVariant } from '@/styles/global.styles';
import Heading from '../Heading/Heading';
import useStyles from './SectionHeader.styles';

interface SectionHeaderProps {
  className?: string;
  subheadingClassName?: string;
  eyebrow?: string;
  heading?: string;
  subheading?: string;
  isOnDark?: boolean;
  fixed?: boolean;
  subheadingFontStyle?:
    | ResponsiveTypeVariant.body
    | ResponsiveTypeVariant.bodyLg;
  headingSpacingValue?: 0 | 1;
  isH1?: boolean;
}

export default function SectionHeader({
  className,
  subheadingClassName,
  eyebrow,
  heading,
  subheading,
  isOnDark = true,
  fixed = false,
  subheadingFontStyle = ResponsiveTypeVariant.bodyLg,
  headingSpacingValue = 0,
  isH1 = false,
}: SectionHeaderProps): React.JSX.Element {
  const { classes: globalClasses } = useGlobalStyles({ fixed });
  const { classes, cx } = useStyles({ headingSpacingValue });

  return (
    <div
      className={cx(
        classes.contentContainer,
        isOnDark ? classes.onDark : classes.onLight,
        className
      )}
    >
      {eyebrow && <Eyebrow text={eyebrow} isOnDark={isOnDark} />}
      {heading && (
        <Heading
          level={isH1 ? 'h1' : 'h2'}
          classNameOverride={cx(
            isH1 ? globalClasses.h1 : globalClasses.h2,
            'primaryTextColor'
          )}
        >
          {heading}
        </Heading>
      )}

      {subheading && (
        <p
          className={cx(
            classes.subheading,
            globalClasses[subheadingFontStyle],
            'accentTextColor',
            subheadingClassName
          )}
        >
          {subheading}
        </p>
      )}
    </div>
  );
}
